import { Menu } from '@base-ui/react';
import cx from 'classnames';
import { Icon } from '@components/icon/Icon';
import { useIsOpen } from '@shared/hooks/useIsOpen';
import typography from '~styles/typography.scss';
import styles from '../../OptionsMenu.scss';
import { ConfirmDeleteServerModal } from './ConfirmDeleteServerModal';

export const ServersOptionsMenu = () => {
  const {
    isOpen: isConfirmDeleteServerModalOpen,
    open: openConfirmDeleteServerModal,
    close: closeConfirmDeleteServerModal,
  } = useIsOpen();

  return (
    <>
      <Menu.Root>
        <Menu.Trigger
          className={cx(styles.button, typography.h8)}
          aria-label="Server details options"
        >
          <Icon name="options" className={styles.icon} />
        </Menu.Trigger>
        <Menu.Portal>
          <Menu.Positioner
            side="bottom"
            sideOffset={12}
            className={styles.positioner}
          >
            <Menu.Popup className={styles.popup}>
              <Menu.Arrow className={styles.arrow}>
                <Icon name="arrowPopover" />
              </Menu.Arrow>
              <Menu.Item
                className={styles.menuItem}
                onClick={openConfirmDeleteServerModal}
              >
                Delete Server
              </Menu.Item>
            </Menu.Popup>
          </Menu.Positioner>
        </Menu.Portal>
      </Menu.Root>
      <ConfirmDeleteServerModal
        closeConfirmDeleteServerModal={closeConfirmDeleteServerModal}
        isConfirmDeleteServerModalOpen={isConfirmDeleteServerModalOpen}
      />
    </>
  );
};
